import InfoOutlined from '@mui/icons-material/InfoOutlined';
import type { TooltipProps } from '@mui/material';
import { Tooltip } from '@mui/material';
import type { FC } from 'react';

export type LabelTooltipProps = {
  text?: string | null;
  placement?: TooltipProps['placement'];
};

export const LabelTooltip: FC<LabelTooltipProps> = ({ text, placement = 'right' }) => {
  return text ? (
    <Tooltip title={text} placement={placement} arrow>
      <InfoOutlined sx={{ fontSize: 'medium' }} color="primary" />
    </Tooltip>
  ) : null;
};
